import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ServiceInterface } from '../interfaces/service.interface';
import { Import } from '../models/import.model';
import { environment } from './../../../environments/environment';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class ImportService implements ServiceInterface {
  API_BASE_URL: string = environment.API;

  constructor(private _httpService: HttpService) {
        this.API_BASE_URL = environment.API;
      }

  loadAll(payload?: any): Observable<Import[]> {
    const url = `${this.API_BASE_URL}/imports`;

    return this._httpService.get(url, payload).pipe(map((result: any) => result));
  }

  loadOne(id: number): Observable<Import> {
    const url = `${this.API_BASE_URL}/imports/${id}`;

    return this._httpService.get(url).pipe(map((result: any) => result.data));
  }

  upload(payload: any): Observable<Import> {
    const url = `${this.API_BASE_URL}/administer-requests/import-file`;

    return this._httpService.postFile(url, payload);
  }

  create(payload: any): Observable<Import> {
    const url = `${this.API_BASE_URL}/administer-requests/save-request`;

    return this._httpService.postFile(url, payload);
  }

  update(id: number, payload: any): Observable<Import> {
    const url = `${this.API_BASE_URL}/imports/${id}`;

    return this._httpService.put(url, payload).pipe(map((result: any) => result.data));
  }

  destroy(id: number): boolean {
    return;
  }

}
